import { localisedValue } from "utils"

export const accountantsTransformer = data =>
  !data
    ? []
    : data?.map(accountant => ({
        id: accountant?.id,
        value: accountant?.id,
        label: `${localisedValue({ object: accountant, key: "name" })} - ${
          localisedValue({
            object: accountant?.UserDesignation,
            key: "short",
          }) || ""
        }`,
      }))
